<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-chart-area"></i>
        Usuarios
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administratorHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'chartsDirective' }">
                <span class="has-text-black">
                  <i class="fas fa-chart-area"></i>
                  Usuarios
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div slot="contenido">
        <div class="box">
          <b-button class="mb-4 is-small" type="is-primary" icon-left="plus" @click="showCreate">Crear usuario</b-button>
          <b-table
            :data="users"
            :loading="isLoading"
            paginated
          >
            <template>
              <b-table-column searchable field="rut" label="Rut" v-slot="props">{{props.row.rut}}</b-table-column>
              <b-table-column searchable field="fullName" label="Nombre" v-slot="props">{{props.row.fullName}}</b-table-column>
              <b-table-column searchable field="email" label="Correo electrónico" v-slot="props">{{props.row.email}}</b-table-column>
              <b-table-column searchable field="role.type" label="Perfil" v-slot="props">{{props.row.role.type}}</b-table-column>
              <b-table-column searchable field="stablishment.name" label="Establecimiento" v-slot="props">{{props.row.stablishment.name}}</b-table-column>
              <b-table-column field="modificar" label="Modificar" v-slot="props">
                <b-tooltip label="Modificar usuario" type="is-light">
                  <b-button
                    class="button is-primary is-small"
                    @click="showEdit(props.row.id)"
                  >
                    <b-icon pack="fas" icon="pen"></b-icon>
                  </b-button>
                </b-tooltip>
                <b-tooltip label="Cambiar contraseña" type="is-light" style="margin-left: .5em">
                  <b-button
                    type="is-danger is-small"
                    icon-left="sync-alt"
                    @click="openModalReset(props.row.id)"
                  ></b-button>
                </b-tooltip>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="frown-open" size="is-large"></b-icon>
                  </p>
                  <p>Sin Datos</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>

<script>
import CreateUser from "./../../../components/mantainers/user/CreateUser";
import EditUser from "./../../../components/mantainers/user/EditUser";
import {getUsers} from "./../../../services/user";
import PlantillaContenido from "../../../template/PlantillaContenido.vue";
import ResetPassword from "../../../components/general/ResetPassword";
export default {
  components: {
    PlantillaContenido
  },
  data() {
    return {
      isLoading: true,
      users: []
    }
  },
  async mounted() {
    this.isLoading = true;
    await this.loadUsers();
    this.isLoading = false;
  },
  methods: {
    async loadUsers() {
      let users = await getUsers(this.$http);
      this.users = users.map(user => {
        return {
          ...user,
          fullName: `${user.name} ${user.apepat} ${user.apemat}`
        }
      });
    },
    showCreate() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateUser,
        props: {
          loadUsers: this.loadUsers,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    showEdit(userId) {
      this.$buefy.modal.open({
        parent: this,
        component: EditUser,
        props: {
          userId,
          loadUsers: this.loadUsers,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openModalReset(id) {
      this.$buefy.modal.open({
        parent: this,
        component: ResetPassword,
        props: {
          user_id: id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
  }
};
</script>

<style>
</style>